import { jsxs as A, jsx as b } from "react/jsx-runtime";
import { useRef as B } from "react";
import { u as x } from "./index-6a632112.mjs";
import { b as t, r as L, k as R, l as W, s as e, Q as U } from "./themes-5f0b3c3d.mjs";
import { l as f } from "./lineHeights-72d3110c.mjs";
import { t as l } from "./textStyles-42cab346.mjs";
import { useAccessibilityProps as j } from "./accessibility.js";
import "./fontWeights-a25f8f91.mjs";
const E = (o) => {
  switch (o.$buttonColor) {
    case "onColor":
      return `
      &:focus-visible {
        outline: 2px solid ${o.theme.components.button.onColor.focusRing};
        outline-offset: 2px;
      }
      `;
    case "danger":
      return `
      &:focus-visible {
        outline: 2px solid ${o.theme.components.button.textColorDestructiveOutline};
        outline-offset: 2px;
      }
      `;
    case "default":
    default:
      return `
      &:focus-visible {
        outline: 2px solid ${o.theme.components.button.focusRingColor};
        outline-offset: 2px;
      }
      `;
  }
}, N = (o) => {
  if (o.$buttonColor === "onColor")
    switch (o.$buttonType) {
      case "secondary":
        return `
                border: ${t["2x"]} solid ${o.theme.components.button.onColor.secondary.disabled.outlineColor};
                color: ${o.theme.components.button.onColor.secondary.disabled.textColor};
                background-color: ${o.theme.components.button.onColor.secondary.disabled.backgroundColor};
                `;
      case "text":
        return `
                padding-left: ${e["1x"]};
                padding-right: ${e["1x"]};
                border: ${t["2x"]} solid ${o.theme.components.button.onColor.text.disabled.outlineColor};
                color: ${o.theme.components.button.onColor.text.disabled.textColor};
                background-color: ${o.theme.components.button.onColor.text.disabled.backgroundColor};
                `;
      case "default":
      default:
        return `
                border: ${t["2x"]} solid ${o.theme.components.button.onColor.default.disabled.outlineColor};
                color: ${o.theme.components.button.onColor.default.disabled.textColor};
                background-color: ${o.theme.components.button.onColor.default.disabled.backgroundColor};
                `;
    }
  else
    switch (o.$buttonType) {
      case "secondary":
        return `
                border: ${t["2x"]} solid ${o.theme.components.button.default.secondary.disabled.outlineColor};
                color: ${o.theme.components.button.default.secondary.disabled.textColor};
                background-color: ${o.theme.components.button.default.secondary.disabled.backgroundColor};
                `;
      case "text":
        return `
                padding-left: ${e["1x"]};
                padding-right: ${e["1x"]};
                border: ${t["2x"]} solid ${o.theme.components.button.default.text.disabled.outlineColor};
                color: ${o.theme.components.button.default.text.disabled.textColor};
                background-color: ${o.theme.components.button.default.text.disabled.backgroundColor};
                `;
      case "default":
      default:
        return `
                border: ${t["2x"]} solid ${o.theme.components.button.default.default.disabled.outlineColor};
                color: ${o.theme.components.button.default.default.disabled.textColor};
                background-color: ${o.theme.components.button.default.default.disabled.backgroundColor};
                `;
    }
}, G = x.button`
  && {
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    border-width: ${t["2x"]};
    border-style: solid;
    border-color: transparent;
    border-radius: ${L["2x"]};
    font-family: ${R};
    letter-spacing: ${W[0]};
    white-space: nowrap;
    cursor: pointer;
    --icon-margin: 8px;
    vertical-align: middle;

    ${(o) => {
  if (!o.$isAnchorUnderlined)
    return `
      text-decoration: none;
    `;
}}
    ${(o) => {
  switch (o.$size) {
    case "small":
      return `
        --svg-wrapper-width: ${e["4x"]};
        --svg-wrapper-height: ${e["4x"]};
        height: ${e["8x"]};

        padding: ${e["1x"]} ${e["4x"]};
        font-size: ${l.body.medium.s.fontSize};
        font-weight: ${l.body.medium.s.fontWeight};
        line-height: ${f.small};
        `;
    case "large":
      return `
        --svg-wrapper-width: ${e["5x"]};
        --svg-wrapper-height: ${e["5x"]};
        height: ${e["12x"]};

        padding: ${e["2x"]} ${e["8x"]};
        font-size: ${l.body.medium.l.fontSize};
        font-weight: ${l.body.medium.l.fontWeight};
        line-height: ${f.large};
        `;
    case "medium":
    default:
      return `
        --svg-wrapper-width:  ${e["5x"]};
        --svg-wrapper-height:  ${e["5x"]};
        padding: ${e["1x"]} ${e["6x"]};
        font-size: ${l.body.medium.m.fontSize};
        font-weight: ${l.body.medium.m.fontWeight};
        line-height: ${f.medium};
        `;
  }
}};

    ${(o) => {
  if (o.$isDisabled)
    return N(o);
  switch (o.$buttonColor) {
    case "onColor":
      switch (o.$buttonType) {
        case "secondary":
          return `
                border: ${t["2x"]} solid ${o.theme.components.button.onColor.secondary.borderOutlineColor};
                color: ${o.theme.components.button.onColor.secondary.textColor};
                background-color: transparent;

                &:hover {
                  background-color: ${o.theme.components.button.onColor.secondary.hover.backgroundColor};
                  border: ${t["2x"]} solid ${o.theme.components.button.onColor.secondary.hover.borderOutlineColor};
                  color: ${o.theme.components.button.onColor.secondary.hover.textColor};
                }
                `;
        case "text":
          return `
                color: ${o.theme.components.button.onColor.text.textColor};
                background-color: transparent;
                padding-left: ${e["1x"]};
                padding-right: ${e["1x"]};
                &:hover {
                  background-color: ${o.theme.components.button.onColor.text.hover.backgroundColor};
                  color: ${o.theme.components.button.onColor.text.hover.textColor};
                }
                `;
        case "default":
        default:
          return `
                color: ${o.theme.components.button.onColor.default.textColor};
                background-color: ${o.theme.components.button.onColor.default.backgroundColor};

                &:hover {
                  background-color: ${o.theme.components.button.onColor.default.hover.backgroundColor};
                }
                `;
      }
    case "danger":
      switch (o.$buttonType) {
        case "text":
          return `
                color: ${o.theme.components.button.textColorDestructiveText};
                background-color: transparent;
                padding-left: ${e["1x"]};
                padding-right: ${e["1x"]};

                &:hover {
                  background-color: ${o.theme.components.button.backgroundColorDestructiveTextHover};
                  color: ${o.theme.components.button.textColorDestructiveTextHover};
                }
                `;
        case "secondary":
          return `

                border: ${t["2x"]} solid ${o.theme.components.button.borderColorDestructiveOutline};
                color: ${o.theme.components.button.textColorDestructiveOutline};
                background-color: transparent;

                &:hover {
                  background-color: ${o.theme.components.button.backgroundColorDestructiveOutlineHover};
                  border: ${t["2x"]} solid ${o.theme.components.button.borderColorDestructiveOutlineHover};
                  color: ${o.theme.components.button.textColorDestructiveOutlineHover};
                }
                `;
        case "default":
        default:
          return `
                color: ${o.theme.components.button.textColorDestructiveSolid};
                background-color: ${o.theme.components.button.backgroundColorDestructiveSolid};

                &:hover {
                  background-color: ${o.theme.components.button.backgroundColorDestructiveSolidHover};
                }
                `;
      }
    case "default":
    default:
      switch (o.$buttonType) {
        case "text":
          return `
                color: ${o.theme.components.button.textColorPrimaryText};
                background-color: transparent;
                padding-left: ${e["1x"]};
                padding-right: ${e["1x"]};
                &:hover {
                  background-color: ${o.theme.components.button.backgroundColorPrimaryTextHover};
                  color: ${o.theme.components.button.textColorPrimaryTextHover};
                }
                `;
        case "secondary":
          return `

                border: ${t["2x"]} solid ${o.theme.components.button.borderColorPrimaryOutline};
                color: ${o.theme.components.button.textColorPrimaryOutline};
                background-color: transparent;

                &:hover {
                  background-color: ${o.theme.components.button.backgroundColorPrimaryOutlineHover};
                  border: ${t["2x"]} solid ${o.theme.components.button.borderColorPrimaryOutlineHover};
                  color: ${o.theme.components.button.textColorPrimaryOutlineHover};
                }
                `;
        case "default":
        default:
          return `
                color: ${o.theme.components.button.textColorPrimarySolid};
                background-color: ${o.theme.components.button.backgroundColorPrimarySolid};

                &:hover {
                  background-color: ${o.theme.components.button.backgroundColorPrimarySolidHover};
                }
                `;
      }
  }
}};

    ${(o) => {
  if (o.$isDisabled)
    switch (o.$buttonColor) {
      case "onColor":
        return `
      &:focus-visible {
        outline: 2px solid ${o.theme.components.button.onColor.focusRing};
        outline-offset: 2px;
      }
      `;
      case "danger":
        return `
      &:focus-visible {
        outline: 2px solid ${o.theme.components.button.textColorDestructiveOutline};
        outline-offset: 2px;
      }
      `;
      case "default":
      default:
        return `
      &:focus-visible {
        outline: 2px solid ${o.theme.components.button.focusRingColor};
        outline-offset: 2px;
      }
      `;
    }
  else
    return E(o);
}};
  }
`, k = x.div`
  ${({ $rightIcon: o }) => o && "margin-left: var(--icon-margin);"};
  ${({ $leftIcon: o }) => o && "margin-right: var(--icon-margin);"};
  width: var(--svg-wrapper-width);
  height: var(--svg-wrapper-height);
  display: flex;

  svg,
  img {
    width: var(--svg-wrapper-width);
    height: var(--svg-wrapper-height);
  }
`, I = (o) => o?.charAt(0) !== "/", Q = (o, n) => n === "tertiary" ? "onColor" : o === "destructive" ? "danger" : "default", _ = (o) => o === "solid" ? "default" : o === "outline" ? "secondary" : o === "text" ? "text" : "default", F = ({
  size: o = "medium",
  isDisabled: n = !1,
  onClick: m,
  children: i,
  className: h,
  leftIcon: d,
  rightIcon: c,
  variant: a = "solid",
  color: $ = "primary",
  isAnchorUnderlined: w = !1,
  href: u,
  as: s = "button",
  target: r,
  accessibilityOptions: p = {},
  id: D,
  dataTestId: P,
  buttonColor: O = Q($, a),
  buttonType: H = _(a),
  ...S
}) => {
  const g = B(), T = j(
    "button",
    {
      ...p,
      ariaDisabled: n
    },
    g
  );
  u && I(u) ? r = r || "_blank" : r = r || "_self";
  const C = s === "a", v = s !== "a" && s !== "button";
  function z(y) {
    n ? y.preventDefault() : m?.(y);
  }
  return /* @__PURE__ */ A(
    G,
    {
      $isDisabled: n,
      onClick: z,
      disabled: n,
      $size: o,
      $buttonColor: O,
      $buttonType: H,
      className: h,
      "data-testid": P,
      id: D,
      as: s,
      ...C && (C && {
        target: r,
        href: u,
        $isAnchorUnderlined: w
      }),
      ref: g,
      ...v && (v && {
        target: r,
        href: u,
        to: u
      }),
      ...S,
      ...T,
      children: [
        d && i && /* @__PURE__ */ b(k, { $leftIcon: !0, children: d }),
        i,
        c && i && /* @__PURE__ */ b(k, { $rightIcon: !0, children: c })
      ]
    }
  );
}, V = x.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${e["6x"]};
  @media ${U.tabletAndUp} {
    flex-direction: row;
  }
`, no = ({
  size: o = "medium",
  buttonColor: n = "default",
  buttonType: m = "default",
  buttonData: i,
  style: h,
  className: d
}) => /* @__PURE__ */ b(V, { style: h, className: d, children: i.map(({ buttonText: c, ...a }, $) => /* @__PURE__ */ b(
  F,
  {
    size: o,
    buttonColor: n,
    buttonType: m,
    ...a,
    children: c
  },
  `button-${$}`
)) });
export {
  F as Button,
  no as ButtonGroup
};
